import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.company.report.input');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-company-report-input',
template: templateSource || '',
    styles: [`

/* file: /opt/app/project/main/build/src/app/page.company.report.input/view.scss */
:host {
  display: block;
}`],
})
export class PageCompanyReportInputComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public loading: boolean = true;
    public saving: boolean = false;
    public errorMessage: string = '';
    public requestId: string = '';
    public requestToken: string = '';
    public menu: string = 'report';
    public request: any = null;
    public company: any = null;
    public companyStatus: any = null;
    public responseForm: any = { answers: [], attachments: [] };

    public dataMenus: any[] = [
        { key: 'shareholder', label: '주주명부' },
        { key: 'financial', label: '재무제표' },
        { key: 'patent', label: '특허현황' },
        { key: 'business', label: '사업현황' },
        { key: 'tech', label: '기술개발현황' },
        { key: 'support', label: '지원사업현황' },
        { key: 'workforce', label: '인력현황' },
        { key: 'stakeholder_change', label: '투자계약상 이해관계인' },
        { key: 'overseas', label: '해외진출현황' }
    ];

    public async ngOnInit() {
        await this.service.init();
        const segment = WizRoute.segment || {};
        this.requestId = segment.request_id || '';
        this.menu = segment.menu || 'report';
        const query = new URLSearchParams(window.location.search || '');
        this.requestToken = query.get('token') || query.get('request_token') || '';
        await this.loadReport();
    }

    public async loadReport() {
        this.loading = true;
        this.errorMessage = '';
        await this.service.render();
        if (!this.requestId) {
            this.loading = false;
            this.errorMessage = '기업보고 요청 링크가 올바르지 않습니다.';
            await this.service.render();
            return;
        }
        try {
            const { code, data } = await wiz.call('load_report', {
                request_id: this.requestId,
                request_token: this.requestToken
            });
            if (code === 200) {
                this.request = data.request || null;
                this.company = data.company || null;
                this.companyStatus = data.company_status || null;
                this.normalizeResponseForm();
            } else {
                this.errorMessage = data?.message || '기업보고 요청을 불러오지 못했습니다.';
            }
        } catch (e) {
            this.errorMessage = '기업보고 요청을 불러오지 못했습니다.';
        } finally {
            this.loading = false;
            await this.service.render();
        }
    }

    public normalizeResponseForm() {
        const response = this.request?.report_response || {};
        const savedAnswers = response.answers || [];
        const answerMap: any = {};
        for (const item of savedAnswers) {
            if (item?.id) answerMap[item.id] = item;
            if (item?.question) answerMap[item.question] = item;
        }

        const questions = this.request?.questions || [];
        this.responseForm.answers = questions.map((question: any, index: number) => {
            const id = question.id || String(index + 1);
            const saved = answerMap[id] || answerMap[question.question] || {};
            return {
                id,
                question: question.question || '',
                answer: saved.answer || ''
            };
        });
        if (this.responseForm.answers.length === 0 && savedAnswers.length > 0) {
            this.responseForm.answers = savedAnswers;
        }
        this.responseForm.attachments = (response.attachments || []).map((item: any) => ({
            title: item.title || '',
            name: item.name || '',
            original_name: item.original_name || item.name || '',
            download_name: item.download_name || item.title || item.name || '',
            url: item.url || '',
            upload_status: item.upload_status || (item.url ? 'uploaded' : 'pending')
        }));
    }

    public tabClass(key: string): string {
        if (this.menu === key) return 'rounded-lg bg-zinc-900 px-3 py-2 text-sm font-semibold text-white';
        return 'rounded-lg px-3 py-2 text-sm font-semibold text-zinc-700 hover:bg-zinc-100';
    }

    public async setMenu(key: string) {
        this.menu = key;
        let url = `/company-report-input/${this.requestId}`;
        if (key !== 'report') url += `/${key}`;
        if (this.requestToken) url += `?token=${encodeURIComponent(this.requestToken)}`;
        this.service.href(url);
        if (key === 'report') {
            await this.loadReport();
            return;
        }
        await this.service.render();
    }

    public showCompanyDataTabs(): boolean {
        return !!this.request?.company_data_required;
    }

    public companyDataStatusItems(): any[] {
        return this.companyStatus?.data || [];
    }

    public dataStatusClass(item: any): string {
        if (item?.is_new) return 'bg-emerald-50 text-emerald-700';
        return 'bg-red-50 text-red-600';
    }

    public dataStatusLabel(item: any): string {
        return item?.is_new ? '입력됨' : '미입력';
    }

    public attachmentTitle(file: any): string {
        return this.attachmentFileName(file);
    }

    public attachmentFileName(file: any): string {
        return file?.title || file?.requested_name || file?.download_name || file?.name || '첨부파일';
    }

    public attachmentUrl(file: any): string {
        const url = file?.url || '';
        const filename = this.attachmentFileName(file);
        const marker = '/file/download/';
        const index = url.indexOf(marker);
        if (!url || !filename || index < 0) return url;
        const prefix = url.slice(0, index + marker.length);
        const rest = url.slice(index + marker.length);
        const fileId = rest.split('/')[0];
        if (!fileId) return url;
        return `${prefix}${fileId}/${encodeURIComponent(filename)}`;
    }

    public attachmentOriginalName(file: any): string {
        const original = file?.original_name || file?.name || '';
        const current = this.attachmentFileName(file);
        return original && original !== current ? original : '';
    }

    public normalizedAttachments(rows: any[] = []): any[] {
        return (rows || []).map((file: any) => ({
            ...file,
            original_name: file?.original_name || file?.name || '',
            download_name: this.attachmentFileName(file)
        }));
    }

    public attachmentStatusText(file: any): string {
        if (file?.upload_status === 'uploaded') return '업로드 완료';
        if (file?.upload_status === 'uploading') return '업로드 중';
        if (file?.upload_status === 'failed') return '업로드 실패';
        return '파일 미선택';
    }

    public attachmentStatusClass(file: any): string {
        if (file?.upload_status === 'uploaded') return 'bg-emerald-50 text-emerald-700';
        if (file?.upload_status === 'failed') return 'bg-red-50 text-red-600';
        return 'bg-amber-50 text-amber-700';
    }

    public async addSubmissionAttachment() {
        if (!Array.isArray(this.responseForm.attachments)) this.responseForm.attachments = [];
        this.responseForm.attachments.push({ title: '', name: '', url: '', upload_status: 'pending' });
        await this.service.render();
    }

    public async uploadSubmissionAttachment(index: number) {
        const attachment = this.responseForm.attachments?.[index];
        if (!attachment) return;
        const files = await this.service.file.select();
        if (!files || files.length === 0) return;
        const file = files[0];
        await this.service.loading.show();
        try {
            attachment.original_name = file.name;
            attachment.name = file.name;
            attachment.download_name = this.attachmentFileName(attachment);
            attachment.url = '';
            attachment.upload_status = 'uploading';
            await this.service.render();
            const fd = new FormData();
            fd.append('upload', file);
            const { url } = await this.service.file.upload('/file/upload?mode=company_report_input', fd, async () => { });
            attachment.url = url;
            attachment.upload_status = 'uploaded';
        } catch (e) {
            attachment.upload_status = 'failed';
        }
        await this.service.loading.hide();
        await this.service.render();
    }

    public async removeSubmissionAttachment(index: number) {
        this.responseForm.attachments.splice(index, 1);
        await this.service.render();
    }

    public async saveResponse() {
        if (this.saving) return;
        const missingTitles = (this.responseForm.attachments || []).filter((item: any) => !String(item?.title || '').trim());
        if (missingTitles.length > 0) {
            await this.service.alert.error('제출 첨부파일 제목을 입력해 주세요.');
            return;
        }
        const incomplete = (this.responseForm.attachments || []).filter((item: any) => item.upload_status !== 'uploaded' || !item.url);
        if (incomplete.length > 0) {
            await this.service.alert.error('업로드가 완료되지 않은 제출 첨부파일이 있습니다.');
            return;
        }

        this.saving = true;
        await this.service.render();
        try {
            const { code, data } = await wiz.call('save_response', {
                request_id: this.requestId,
                request_token: this.requestToken,
                answers: JSON.stringify(this.responseForm.answers || []),
                attachments: JSON.stringify(this.normalizedAttachments(this.responseForm.attachments || []))
            });
            if (code === 200) {
                this.request = data.request || this.request;
                this.normalizeResponseForm();
                await this.service.alert.success('저장되었습니다.');
            } else {
                await this.service.alert.error(data?.message || '저장에 실패했습니다.');
            }
        } catch (e) {
            await this.service.alert.error('저장에 실패했습니다.');
        } finally {
            this.saving = false;
        }
        await this.loadReport();
    }
}

export default PageCompanyReportInputComponent;